// lib/masterSessionPins.ts
// Pinning a Master conversation is something the user decided, not something their machine
// decided, so it lives in User.preferences (pinnedMasterSessionIds) and follows them to any
// browser. Both consumers, the left-bar Pinned/Recents split and the in-conversation menu,
// read that key through the Zustand store, which is also what keeps them in sync live.

import type { KernelHandle } from '#types/types';

/**
 * Toggle a Master session's pin and persist it.
 * No-op while preferences are not hydrated (undefined = unknown truth): writing then would
 * replace the user's real pin list with a single id.
 */
export function toggleMasterSessionPin(kernel: KernelHandle, sessionId: string): void {
  const current = kernel.getUserPreferences()?.pinnedMasterSessionIds;
  if (!Array.isArray(current)) return;
  const next = new Set(current);
  if (!next.delete(sessionId)) next.add(sessionId);
  void kernel.updateAndSaveUserPreference('pinnedMasterSessionIds', [...next]);
}
